import GustoStore from 'modules/Payroll/common/Gusto/Store';

export default class RootStore {
    gustoStore: GustoStore;

    constructor() {
        this.gustoStore = new GustoStore();
    }
}
